module.exports = __webpack_public_path__ + "static/media/uj_dokfeltoltes2.b0c44d37.jpg";